module.exports = __webpack_public_path__ + "static/media/icon-phone-call.b9e84bfc.svg";